import React from 'react'
import { InputNumber } from 'primereact/inputnumber'

const NumericFilterTemplate = ({ options, field }) => {
    const filterOptions = options[field + 'Options']
    return (
        <InputNumber
            value={options.value}
            options={filterOptions}
            onChange={(e) => options.filterCallback(e.value, options.index)}
            placeholder={`Search by ${field}`}
            useGrouping={false}/>
    )
}

export default NumericFilterTemplate
